export { default as default } from './VideoBase';
